export default __webpack_public_path__ + "static/media/summarize_icon.2f563f56.svg";